/**
 * Product Q&A Widget — front-end (injected into Shopify product pages).
 * Self-hosted replacement for Ding AI. No dependencies.
 *
 *   <script src="https://YOUR-APP.up.railway.app/widget.js"
 *           data-product="raven" defer></script>
 *
 * Features beyond Ding AI:
 *   - Polished chat UI (gradient header, avatar w/ online dot, animated bubbles).
 *   - Links rendered as tappable pill buttons (WhatsApp / tracking / policy / product).
 *   - In-chat product card with real Add-to-Cart (Shopify /cart/add.js) + checkout.
 *   - Instant zero-cost answers for the preset questions (served from config).
 *   - Quick-reply chips.
 */
(function () {
  'use strict';

  var self = document.currentScript ||
    (function () { var s = document.querySelectorAll('script[src*="widget.js"]'); return s[s.length - 1]; })();
  if (!self) return;

  var API_BASE = 'https://product-qa-widget-production.up.railway.app';   // מוגש מה-theme; ה-API נשאר בריילוויי
  var PRODUCT = self.getAttribute('data-product') || 'raven';
  // "thankyou" → injected on the order-status/thank-you page (Grow-friendly upsell,
  // no re-charge: Maya personally offers add-ons the shopper buys in a quick 2nd checkout).
  var MODE = self.getAttribute('data-mode') || '';

  if (window.__pqaWidgetLoaded) return;
  window.__pqaWidgetLoaded = true;

  // Storefront locale from the URL (e.g. /ru/products/..., /ar/products/...).
  var LOCALE = (location.pathname.match(/^\/([a-z]{2})\//) || [])[1] || '';
  var ON_PRODUCT_PAGE = /\/products\//.test(location.pathname);

  // Which product page are we on? One brand can sell several products (Mistly+
  // for eyes, Hear+ for ears), and the server keys its `variants` block by this
  // handle to serve the right questions, answers, knowledge and cart product.
  // Read from the URL, so adding a product needs no theme change.
  var PAGE_HANDLE = (function () {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return String(m[1]).toLowerCase(); }
  })();

  // Storage is scoped to the page too - otherwise a shopper who chatted about the
  // eye device would walk into the ear page mid-conversation about the wrong product.
  var SCOPE = PRODUCT + (PAGE_HANDLE ? '_' + PAGE_HANDLE : '');
  var LS_KEY = 'pqa_state_' + SCOPE;
  var CHAT_KEY = 'pqa_chat_' + SCOPE;
  // Conversation id for the owner's admin console (groups turns into one chat).
  var CHAT_ID = (function () {
    try {
      var k = 'pqa_chat_id_' + SCOPE;
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return 'c-anon'; }
  })();

  // Marketing analytics: report widget engagement to Meta Pixel / GA if present,
  // so the owner can see the widget's conversion impact in Events Manager.
  function track(name, params) {
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params || {}); } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
      else if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }

  // ------------------------------------------------------------- helpers
  function el(tag, styles, props) {
    var e = document.createElement(tag);
    if (styles) e.style.cssText = styles;
    if (props) Object.keys(props).forEach(function (k) { e[k] = props[k]; });
    return e;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function readState() { try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (e) { return {}; } }
  function writeState(s) { try { localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch (e) {} }

  // Pill labels are localizable via config text (pill*) — Hebrew defaults.
  function linkLabel(url, T) {
    T = T || {};
    var u = url.toLowerCase();
    if (/wa\.me|whatsapp/.test(u)) return T.pillWhatsapp || '💬 פתחו וואטסאפ';
    if (/מעקב|tracking|track/.test(url)) return T.pillTracking || '📦 מעקב הזמנה';
    if (/שאלות|faq/.test(url)) return T.pillFaq || '📄 שאלות נפוצות';
    if (/צור-קשר|contact/.test(url)) return T.pillContact || '✉️ צור קשר';
    if (/\/products\//.test(u)) return T.pillProduct || '🎧 לדף המוצר';
    if (/מדיניות|policy|returns|shipping|משלוח|החזר/.test(url)) return T.pillPolicy || '📄 למדיניות';
    try { return '🔗 ' + new URL(url).hostname.replace('www.', ''); } catch (e) { return '🔗 ' + (T.pillLink || 'קישור'); }
  }

  fetch(API_BASE + '/api/config?product=' + encodeURIComponent(PRODUCT) +
        (LOCALE ? '&locale=' + LOCALE : '') +
        (PAGE_HANDLE ? '&handle=' + encodeURIComponent(PAGE_HANDLE) : ''))
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cfg) {
      if (!cfg) return;
      // Thank-you page: run the post-purchase upsell flow regardless of URL.
      if (MODE === 'thankyou') { init(cfg); return; }
      // Cart page: also load the upsell strip (accessories cross-sell).
      if (/^\/cart\/?$/.test(location.pathname) && cfg.upsell && !window.__pqaUpsellLoaded) {
        var us = document.createElement('script');
        us.src = API_BASE + '/upsell.js'; us.defer = true;
        us.setAttribute('data-product', PRODUCT);
        document.body.appendChild(us);
      }
      // Product pages: full experience. Other pages: quiet side tab only,
      // and only when the config allows site-wide presence.
      if (!ON_PRODUCT_PAGE && !cfg.showOnAllPages) return;
      init(cfg);
    })
    .catch(function () {});

  function init(cfg) {
    var C = cfg.colors || {};
    // Owner request: unify the WHOLE chat (not just the launcher circle) to a
    // beautiful WhatsApp-green theme - bright green FAB, teal-green header /
    // buttons / bubbles with readable white text.
    C = Object.assign({}, C, {
      headerGradientFrom: '#128C7E',
      headerGradientTo: '#075E54',
      buttonBackground: '#128C7E',
      buttonText: '#ffffff',
      selectedBackground: '#128C7E',
      selectedText: '#ffffff',
      // Real WhatsApp convention: what YOU send is the dark-green bubble, what
      // the other person sends is a plain white one. Keeping that exact split is
      // what makes the thread read as a conversation with a person.
      userBubbleBackground: '#005c4b',
      userBubbleText: '#ffffff',
      aiBubbleBackground: '#ffffff',
      aiBubbleText: '#111b21',
      accent: '#128C7E',
      optionBackground: '#ffffff',
      borderColor: '#0f8a6d',
      launcher: '#25D366',
      launcherText: '#ffffff'
    });
    var WA_BG = '#efeae2';   // WhatsApp chat background (warm cream)

    // Header avatar: a real photo when the config supplies one (set
    // `avatarUrl` in the product config), otherwise the initial as before.
    // A face is the single biggest "there's a person here" cue.
    function avatarEl() {
      var url = cfg.avatarUrl;
      if (url) {
        return el('img',
          'width:38px;height:38px;border-radius:50%;object-fit:cover;display:block;' +
          'background:rgba(255,255,255,.16);',
          { src: url, alt: T.assistantName || '' });
      }
      return el('div',
        'width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.16);backdrop-filter:blur(4px);' +
        'display:flex;align-items:center;justify-content:center;font-weight:800;font-size:16px;color:#fff;',
        { innerText: (T.assistantName || 'ש').trim().charAt(0) });
    }
    var T = cfg.text || {};
    var Z = cfg.size || {};
    var rtl = cfg.rtl !== false;
    var dir = rtl ? 'rtl' : 'ltr';
    var radius = (Z.borderRadius || 22) + 'px';
    var titleSize = (Z.titleSize || 19) + 'px';
    var optSize = (Z.optionSize || 14.5) + 'px';
    var accent = C.accent || '#2563eb';
    var btnBg = C.buttonBackground || '#111';
    var btnTx = C.buttonText || '#fff';

    // fonts
    if (!document.getElementById('pqa-font')) {
      document.head.appendChild(el('link', null, {
        id: 'pqa-font', rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap',
      }));
    }
    var FONT = '"Heebo","Inter",system-ui,-apple-system,sans-serif';

    document.head.appendChild(el('style', null, {
      textContent:
        '@keyframes pqaUp{from{opacity:0;transform:translateY(26px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}' +
        '@keyframes pqaFade{from{opacity:0}to{opacity:1}}' +
        '@keyframes pqaMsg{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}' +
        '@keyframes pqaBlink{0%,80%,100%{opacity:.25;transform:translateY(0)}40%{opacity:1;transform:translateY(-2px)}}' +
        '@keyframes pqaPulse{0%{box-shadow:0 0 0 0 rgba(34,197,94,.5)}70%{box-shadow:0 0 0 6px rgba(34,197,94,0)}100%{box-shadow:0 0 0 0 rgba(34,197,94,0)}}' +
        '@keyframes pqaHeaderShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}' +
        '#pqa-scroll::-webkit-scrollbar{width:6px}#pqa-scroll::-webkit-scrollbar-thumb{background:#d7dbe2;border-radius:3px}' +
        '.pqa-opt:hover{background:' + (C.hover || '#eef0f4') + '!important;transform:translateY(-1px)}' +
        '.pqa-pill:hover{filter:brightness(.94)}' +
        '.pqa-chip:hover{background:' + (C.hover || '#eef0f4') + '!important}' +
        '.pqa-cta:active{transform:scale(.98)}',
    }));

    var messages = [];
    var opened = false;
    var busy = false;               // a reply is streaming — block new sends
    var liveProduct = null;         // product data from /products/handle.js
    var quickRepliesShown = false;
    var chatRestored = false;       // session chat replayed into the modal already

    // Conversation survives page navigation within the visit (sessionStorage).
    function readChat() { try { return JSON.parse(sessionStorage.getItem(CHAT_KEY) || '[]'); } catch (e) { return []; } }
    function saveChat() { try { sessionStorage.setItem(CHAT_KEY, JSON.stringify(messages.slice(-12))); } catch (e) {} }
    function restoreChat(saved) {
      renderChatShell();
      messages = saved.slice();
      saved.forEach(function (m) {
        if (m.role === 'user') bubble('user').innerText = m.content;
        else renderAnswer(bubble('assistant'), m.content);
      });
      quickRepliesShown = true;
      scrollDown();
    }

    // ------------------------------------------------------ shell elements
    var isMobile = window.matchMedia && window.matchMedia('(max-width:640px)').matches;
    var dia = isMobile ? 56 : 62;   // launcher diameter, also the corner offset
    // On a phone the chat takes the screen (that is the right place for it, and
    // the keyboard fix below depends on it). On a desktop it opens in the corner
    // above the launcher, like every chat widget people already know: the page
    // stays readable, stays clickable, and nothing is dimmed behind a modal.
    var overlay = el('div', isMobile
      ? 'position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;' +
        'background:rgba(15,18,25,.42);backdrop-filter:blur(2px);animation:pqaFade .25s ease;padding:16px;font-family:' + FONT + ';'
      // direction:ltr on the layer itself on purpose: the launcher is placed by
      // physical side (left in Hebrew), and flex-start under RTL would send the
      // panel to the opposite corner from its own button.
      : 'position:fixed;inset:0;z-index:2147483000;display:none;align-items:flex-end;direction:ltr;' +
        'justify-content:' + (rtl ? 'flex-start' : 'flex-end') + ';pointer-events:none;background:transparent;' +
        'padding:16px 16px ' + (dia + 30) + 'px;font-family:' + FONT + ';');
    // Chat view height: tall enough for a conversation, short enough to keep
    // the page visible around it (the owner found full-height overwhelming).
    var CHAT_HEIGHT = isMobile ? '70vh' : 'min(620px, calc(100vh - 150px))';
    var modal = el('div',
      'position:relative;width:100%;max-width:' + (isMobile ? '430px' : '410px') + ';' +
      'max-height:' + (isMobile ? '80vh' : 'calc(100vh - 150px)') + ';display:flex;flex-direction:column;' +
      'background:' + (C.popupBackground || '#fff') + ';border-radius:' + radius + ';overflow:hidden;pointer-events:auto;' +
      'border:1.5px solid ' + (C.borderColor || '#e5e7eb') + ';' +
      'box-shadow:0 26px 64px -18px rgba(15,20,25,.45), 0 0 0 1px rgba(15,20,25,.05);' +
      'animation:pqaUp .32s cubic-bezier(.2,.8,.2,1);direction:' + dir + ';');
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // iOS/Android keyboard fix: the on-screen keyboard shrinks only the *visual*
    // viewport, and on iOS it also PANS it — fixed elements stay glued to the
    // layout viewport, so the input bar ends up buried under the keyboard.
    // Fix: while the keyboard is open, pin the overlay to the visible area
    // (top/left/size taken live from visualViewport) so the whole chat — input
    // bar included — rides up with the keyboard.
    if (window.visualViewport && isMobile) {
      var vv = window.visualViewport;
      var vvFit = function () {
        if (overlay.style.display !== 'flex') return;
        var kbOpen = (window.innerHeight - vv.height) > 120;
        if (kbOpen) {
          overlay.style.top = Math.round(vv.offsetTop) + 'px';
          overlay.style.left = Math.round(vv.offsetLeft) + 'px';
          overlay.style.width = Math.round(vv.width) + 'px';
          overlay.style.height = Math.round(vv.height) + 'px';
          overlay.style.right = 'auto';
          overlay.style.bottom = 'auto';
          overlay.style.alignItems = 'flex-start';
          var h = Math.round(vv.height) - 16;
          modal.style.maxHeight = h + 'px';
          if (modal.__isChat) modal.style.height = h + 'px';
        } else {
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.right = '0';
          overlay.style.bottom = '0';
          overlay.style.width = '';
          overlay.style.height = '';
          overlay.style.alignItems = 'center';
          modal.style.maxHeight = '80vh';
          if (modal.__isChat) modal.style.height = CHAT_HEIGHT;
        }
        if (chatBox) chatBox.scrollTop = chatBox.scrollHeight;
      };
      vv.addEventListener('resize', vvFit);
      vv.addEventListener('scroll', vvFit);
      // Keyboard animation ends slightly after focus — re-fit once it settles.
      window.addEventListener('focusin', function () { setTimeout(vvFit, 350); });
    }

    // Floating round launcher + "need help?" speech bubble, on BOTH mobile and
    // desktop. WhatsApp-green by default so it reads instantly as a familiar,
    // trusted chat button (override via config colors.launcher / launcherText).
    var launcherBg = C.launcher || '#25D366';   // WhatsApp green
    var launcherTx = C.launcherText || '#ffffff';
    var tab, hintBubble, hintDismissed = false;
    tab = el('button',
      'position:fixed;z-index:2147483000;bottom:18px;' + (rtl ? 'left:16px;' : 'right:16px;') +
      'width:' + dia + 'px;height:' + dia + 'px;border-radius:50%;display:none;align-items:center;justify-content:center;' +
      'background:' + launcherBg + ';color:' + launcherTx + ';border:none;cursor:pointer;font-size:' + (isMobile ? 24 : 27) + 'px;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.28);transition:transform .15s;',
      { innerText: '💬', title: T.reopenButton || 'צריכים עזרה?' });
    tab.addEventListener('mouseenter', function () { tab.style.transform = 'scale(1.06)'; });
    tab.addEventListener('mouseleave', function () { tab.style.transform = 'none'; });
    // "Need help?" is a shrug. A real question is an invitation, and it also
    // shows the visitor, before a single click, that this thing knows the
    // product. The questions rotate slowly and a click sends the one on screen.
    var hintQs = (cfg.questions || [])
      .map(function (q) { return typeof q === 'string' ? q : (q && (q.q || q.question || q.text)); })
      .filter(function (q) { return typeof q === 'string' && q.length > 2 && q.length < 60; });
    // The bubble alternates: a real question to pull someone in, then the
    // plain "need help?" so the corner does not read as a nagging pitch.
    var HINT_HELP = T.bubbleHint || 'צריכים עזרה?';
    var hintCycle = [];
    hintQs.forEach(function (q) { hintCycle.push({ text: q, ask: true }); hintCycle.push({ text: HINT_HELP, ask: false }); });
    if (!hintCycle.length) hintCycle.push({ text: HINT_HELP, ask: false });
    var hintIdx = 0;
    var hintText = hintCycle[0].text;
    hintBubble = el('div',
      'position:fixed;z-index:2147482999;bottom:' + (isMobile ? 27 : 30) + 'px;' +
      (rtl ? 'left:' : 'right:') + (dia + 26) + 'px;' +
      'display:none;align-items:center;gap:9px;white-space:normal;cursor:pointer;max-width:min(300px,calc(100vw - ' + (dia + 60) + 'px));' +
      'background:#fff;color:#1f2937;border:1px solid rgba(0,0,0,.06);border-radius:16px;' +
      'padding:' + (isMobile ? '9px 13px' : '10px 15px') + ';font-family:' + FONT +
      ';font-weight:600;font-size:' + (isMobile ? 13 : 14) + 'px;direction:' + dir + ';' +
      'box-shadow:0 6px 20px rgba(0,0,0,.18);animation:pqaHintIn .35s ease both;');
    var hintAv = null;
    if (cfg.avatarUrl) {
      hintAv = el('img', 'width:26px;height:26px;border-radius:50%;object-fit:cover;flex:0 0 auto;background:#eef1f4;');
      hintAv.src = cfg.avatarUrl; hintAv.alt = '';
    }
    var hintLabel = el('span', 'max-width:230px;white-space:normal;line-height:1.35;', { innerText: hintText });
    var hintClose = el('span',
      'color:#b0b6c0;font-size:15px;line-height:1;font-weight:700;padding:0 1px;',
      { innerText: '×', title: 'סגור' });
    // Tail pointing toward the round button.
    var hintTail = el('span',
      'position:absolute;bottom:15px;' + (rtl ? 'left:-4px;' : 'right:-4px;') +
      'width:10px;height:10px;background:#fff;border:1px solid rgba(0,0,0,.06);' +
      'border-top:none;' + (rtl ? 'border-right:none;' : 'border-left:none;') +
      'transform:rotate(45deg);');
    if (hintAv) hintBubble.appendChild(hintAv);
    hintBubble.appendChild(hintLabel);
    hintBubble.appendChild(hintClose);
    hintBubble.appendChild(hintTail);
    hintClose.addEventListener('click', function (e) {
      e.stopPropagation(); hintDismissed = true; hintBubble.style.display = 'none';
    });
    // Clicking the bubble does not just open the chat, it asks the question
    // that is on screen, so the visitor's first turn costs them nothing.
    hintBubble.addEventListener('click', function () {
      // On a question the click also asks it; on the plain hint it just opens.
      var cur = hintCycle[hintIdx];
      hintDismissed = true;
      openModal();
      if (cur && cur.ask) { try { startChat(cur.text); } catch (e) {} }
    });
    // A slow rotation: long enough to read, quiet enough not to nag.
    if (hintCycle.length > 1) {
      setInterval(function () {
        if (!hintBubble || hintBubble.style.display !== 'flex') return;
        hintIdx = (hintIdx + 1) % hintCycle.length;
        hintLabel.style.transition = 'opacity .25s ease';
        hintLabel.style.opacity = '0';
        setTimeout(function () {
          hintLabel.innerText = hintCycle[hintIdx].text;
          hintLabel.style.opacity = '1';
          scheduleFit();
        }, 260);
      }, 6500);
    }
    document.body.appendChild(tab);
    if (hintBubble) {
      document.body.appendChild(hintBubble);
      if (!document.getElementById('pqa-hint-kf')) {
        var kf = document.createElement('style'); kf.id = 'pqa-hint-kf';
        kf.textContent = '@keyframes pqaHintIn{from{opacity:0;transform:translateY(6px) scale(.92)}to{opacity:1;transform:none}}';
        document.head.appendChild(kf);
      }
    }
    // Mark our own nodes so the sticky-bar scan can ignore them.
    tab.setAttribute('data-pqa', '1');
    if (hintBubble) hintBubble.setAttribute('data-pqa', '1');
    overlay.setAttribute('data-pqa', '1');

    // Themes (e.g. Shrine) show a sticky add-to-cart bar at the bottom when you
    // scroll a product page, and lift their own scroll-to-top button above it.
    // Ours must do the same or it hides behind the bar. Detect any bottom-anchored
    // fixed/sticky bar (ATC, cookie banner) covering the lower strip and lift the
    // launcher + hint to sit just above it.
    var baseTabB = 18, baseHintB = isMobile ? 27 : 30, fitTimer = null;
    function stickyBarTop() {
      var vh = window.innerHeight, vw = window.innerWidth, top = vh;
      var pts = [[vw * 0.5, vh - 6], [vw * 0.5, vh - 40]];
      for (var i = 0; i < pts.length; i++) {
        var stack;
        try { stack = document.elementsFromPoint(pts[i][0], pts[i][1]) || []; } catch (e) { stack = []; }
        for (var j = 0; j < stack.length; j++) {
          var node = stack[j];
          if (!node || (node.closest && node.closest('[data-pqa]'))) continue;
          var cs = window.getComputedStyle(node);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          if (cs.visibility === 'hidden' || cs.display === 'none') continue;
          var r = node.getBoundingClientRect();
          if (r.bottom < vh - 4 || r.height < 24) continue;   // must hug the bottom, real height
          if (r.width < vw * 0.55) continue;                  // a bar, not a small button
          if (r.top < vh * 0.5) continue;                     // not a full/half-screen overlay
          if (r.top < top) top = r.top;
        }
      }
      return top;   // == vh when there is no bottom bar
    }
    // A cart drawer / modal covers the corner our launcher lives in, and the
    // launcher then sits on top of the checkout button and the price (owner
    // report 21.08.2026, both stores). Hit-test the launcher's own position: if
    // anything fixed/absolute and panel-sized is underneath it, something is
    // open over the page and we get out of the way until it closes.
    // Theme-agnostic on purpose - it catches the cart drawer, its backdrop, and
    // any other modal, without depending on theme-specific class names.
    function overlayCoversLauncher() {
      if (!tab) return false;
      var r = tab.getBoundingClientRect();
      if (!r.width) return false;
      var x = r.left + r.width / 2, y = r.top + r.height / 2;
      var stack;
      try { stack = document.elementsFromPoint(x, y) || []; } catch (e) { return false; }
      var vh = window.innerHeight, vw = window.innerWidth;
      for (var i = 0; i < stack.length; i++) {
        var node = stack[i];
        if (!node || (node.closest && node.closest('[data-pqa]'))) continue;
        var cs = window.getComputedStyle(node);
        if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue;
        if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
        var b = node.getBoundingClientRect();
        // A drawer panel or its full-screen backdrop, not a small floating chip.
        if (b.height >= vh * 0.5 && b.width >= vw * 0.25) return true;
      }
      return false;
    }
    // Hidden via visibility (not display) so the existing display-based logic
    // in syncHint keeps working untouched.
    function applyOverlayHiding() {
      var hide = overlayCoversLauncher();
      var v = hide ? 'hidden' : '', pe = hide ? 'none' : '';
      if (tab) { tab.style.visibility = v; tab.style.pointerEvents = pe; }
      if (hintBubble) { hintBubble.style.visibility = v; hintBubble.style.pointerEvents = pe; }
    }

    // Event-driven checks alone do not hold. The cart drawer fetches its contents
    // before it paints, so a check fired 450ms after the click can still see no
    // drawer - and then nothing looks again and the launcher sits on top of the
    // checkout button. Closing has the mirror problem: the check lands while the
    // close animation is still painting and the launcher never comes back.
    // A half-second hit test is cheap and makes both directions certain.
    // No document.hidden guard here on purpose: browsers already throttle timers
    // in background tabs, and the guard made the watcher dead in any tab the
    // browser considers hidden - which is where it was silently skipping every
    // tick during testing.
    setInterval(function () {
      if (!tab || tab.style.display === 'none') return;
      applyOverlayHiding();
    }, 500);

    function fitLauncher() {
      if (!tab) return;
      applyOverlayHiding();
      if (tab.style.display === 'none' && (isMobile || overlay.style.display !== 'flex')) return;
      var lift = Math.max(0, window.innerHeight - stickyBarTop());
      var tb = baseTabB + (lift ? lift + 8 : 0);
      tab.style.bottom = tb + 'px';
      if (hintBubble) hintBubble.style.bottom = (tb + (baseHintB - baseTabB)) + 'px';
      // The corner panel rides above the launcher, so a sticky add-to-cart bar
      // has to push it up by the same amount or the chat sits on the bar.
      if (!isMobile) overlay.style.paddingBottom = (tb + dia + 12) + 'px';
    }
    // setTimeout, not requestAnimationFrame: rAF is paused in background tabs,
    // which would freeze the launcher (and made this untestable). setTimeout and
    // the interval both keep firing regardless of tab focus.
    function scheduleFit() {
      if (fitTimer) return;
      fitTimer = setTimeout(function () { fitTimer = null; fitLauncher(); }, 80);
    }
    window.addEventListener('scroll', scheduleFit, { passive: true });
    window.addEventListener('resize', scheduleFit, { passive: true });
    // Drawers open on a click and animate in; sample twice so the launcher
    // disappears with the animation rather than 800ms later.
    document.addEventListener('click', function () {
      setTimeout(applyOverlayHiding, 120);
      setTimeout(applyOverlayHiding, 450);
    }, true);
    // Catch bars that appear/leave without a scroll (class toggles) — call
    // fitLauncher directly so it runs even when the tab is backgrounded.
    setInterval(fitLauncher, 800);
    fitLauncher();

    // Keep the "need help?" bubble in lockstep with the round launcher.
    function syncHint() {
      if (!hintBubble) return;
      hintBubble.style.display =
        (!hintDismissed && tab.style.display !== 'none' && overlay.style.display !== 'flex') ? 'flex' : 'none';
      if (hintBubble.style.display === 'flex') scheduleFit();
    }

    function openModal() {
      overlay.style.display = 'flex';
      var so = readState(); so.panelOpenAt = Date.now(); writeState(so);
      // Desktop: the panel sits beside the launcher, so the launcher stays and
      // turns into the close control. Phone: the chat is the screen.
      if (isMobile) tab.style.display = 'none';
      else { tab.style.display = 'flex'; tab.innerText = '✕'; tab.style.fontSize = '22px'; }
      syncHint();
      track('pqa_open', { product: PRODUCT });
      // A chat from earlier in this visit? Bring it back instead of the survey.
      if (!chatRestored) {
        var saved = readChat();
        if (saved.length) restoreChat(saved);
        chatRestored = true;
      }
    }
    function closeModal() {
      overlay.style.display = 'none';
      tab.style.display = 'flex';
      tab.innerText = '💬'; tab.style.fontSize = (isMobile ? 24 : 27) + 'px';
      syncHint();
      var st = readState(); st.dismissedAt = Date.now(); st.panelOpenAt = 0; writeState(st);
    }

    tab.addEventListener('click', function () {
      if (overlay.style.display === 'flex') closeModal(); else openModal();
    });
    // Only the phone overlay is a real backdrop; the desktop one is click through.
    if (isMobile) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display === 'flex') closeModal();
    });
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', T.title || 'שאלות על המוצר');

    // preload live product data (for cart) — silent on failure (e.g. local preview)
    (function preloadProduct() {
      // The page wins over the config default: standing on the Hear+ page must add
      // Hear+ to the cart, never the brand's first product. cfg.productHandle is
      // only the fallback for non-product pages (blog, home) where the widget also runs.
      var handle = PAGE_HANDLE || cfg.productHandle || '';
      if (!handle) return;
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) liveProduct = p; })
        .catch(function () {});
    })();

    // ============================================================ SURVEY VIEW
    function closeBtn() {
      var x = el('button',
        'background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:#aab;padding:0 4px;transition:color .15s;',
        { innerHTML: '&times;', title: 'סגירה' });
      x.addEventListener('mouseenter', function () { x.style.color = '#556'; });
      x.addEventListener('mouseleave', function () { x.style.color = '#aab'; });
      x.addEventListener('click', closeModal);
      return x;
    }

    function renderSurvey() {
      modal.innerHTML = '';
      modal.style.height = 'auto';
      modal.__isChat = false;

      // WhatsApp-style green header (same as the chat) so the very first screen
      // already feels like opening a WhatsApp conversation.
      var head = el('div',
        'display:flex;align-items:center;justify-content:space-between;gap:8px;padding:13px 16px;flex:0 0 auto;' +
        'background:linear-gradient(120deg,' + (C.headerGradientFrom || '#111827') + ',' + (C.headerGradientTo || '#2b3242') + ',' + (C.headerGradientFrom || '#111827') + ');' +
        'background-size:200% 100%;animation:pqaHeaderShift 9s ease-in-out infinite;color:#fff;');
      var who = el('div', 'display:flex;align-items:center;gap:11px;');
      var avWrap = el('div', 'position:relative;flex:0 0 auto;');
      var av = avatarEl();
      var sdot = el('span',
        'position:absolute;bottom:0;' + (rtl ? 'left:0;' : 'right:0;') +
        'width:11px;height:11px;border-radius:50%;background:#25D366;border:2px solid ' + (C.headerGradientTo || '#075E54') + ';animation:pqaPulse 2s infinite;');
      avWrap.appendChild(av); avWrap.appendChild(sdot);
      var nameWrap = el('div');
      nameWrap.appendChild(el('div', 'font-weight:700;font-size:15px;', { innerText: T.assistantName || '' }));
      nameWrap.appendChild(el('div', 'font-size:11.5px;opacity:.75;margin-top:1px;', { innerText: T.statusLine || 'מקוונת · עונה תוך רגע' }));
      who.appendChild(avWrap); who.appendChild(nameWrap);
      var xb = closeBtn(); xb.style.color = 'rgba(255,255,255,.85)';
      head.appendChild(who); head.appendChild(xb);
      modal.appendChild(head);

      // Cream WhatsApp body: a greeting bubble, then the questions.
      var body = el('div', 'background:' + WA_BG + ';padding:15px 15px 16px;');
      var intro = el('div',
        'background:#fff;border-radius:' + (rtl ? '4px 15px 15px 15px' : '15px 4px 15px 15px') + ';' +
        'padding:12px 15px;box-shadow:0 1px 1.5px rgba(0,0,0,.08);margin-bottom:13px;direction:' + dir + ';');
      intro.appendChild(el('div',
        'font-size:' + titleSize + ';font-weight:800;color:' + (C.titleColor || '#0b0b0f') + ';letter-spacing:-.2px;',
        { innerText: T.title || 'יש לך שאלות?' }));
      intro.appendChild(el('div',
        'font-size:12.5px;color:#667085;margin-top:3px;font-weight:500;',
        { innerText: T.subtitle || 'בחרו שאלה או כתבו לנו, נענה תוך רגע' }));
      if (T.socialProof) intro.appendChild(el('div',
        'font-size:12px;color:#b48a26;margin-top:5px;font-weight:700;',
        { innerText: T.socialProof }));
      body.appendChild(intro);

      var list = el('div', 'display:flex;flex-direction:column;gap:7px;');
      (cfg.questions || []).forEach(function (q) { list.appendChild(optionRow(q, false)); });
      list.appendChild(optionRow(T.otherLabel || 'אחר', true));
      body.appendChild(list);

      var footer = el('div', 'padding:9px 0 2px;');
      body.appendChild(footer);
      modal.appendChild(body);
      modal.__footer = footer;
    }

    function optionRow(label, isOther) {
      var row = el('div',
        'display:flex;align-items:center;gap:10px;padding:13px 15px;border-radius:12px;cursor:pointer;' +
        'background:' + (C.optionBackground || '#f7f8fa') + ';box-shadow:0 1px 1.5px rgba(0,0,0,.07);' +
        'border:1px solid rgba(0,0,0,.03);transition:background .15s,transform .12s,box-shadow .15s;' +
        'font-size:' + optSize + ';font-weight:500;color:' + (C.optionText || '#374151') + ';', { className: 'pqa-opt' });
      var dot = el('span',
        'flex:0 0 auto;width:17px;height:17px;border-radius:50%;border:2px solid #cfd5de;box-sizing:border-box;transition:.15s;');
      row.appendChild(el('span', 'flex:1;', { innerText: label }));
      row.appendChild(dot);
      row.addEventListener('click', function () {
        dot.style.borderColor = accent; dot.style.background = accent; dot.style.boxShadow = 'inset 0 0 0 3px #fff';
        setTimeout(function () { isOther ? showOtherInput() : startChat(label); }, 120);
      });
      return row;
    }

    function inputBar(onSend, placeholder) {
      var wrap = el('div',
        'display:flex;gap:6px;align-items:center;background:' + (C.optionBackground || '#f7f8fa') +
        ';border:1.5px solid #e6e9ef;border-radius:22px;padding:5px 6px;direction:' + dir + ';transition:border-color .15s,box-shadow .15s;');
      var input = el('input',
        // 16px: any smaller and iOS Safari auto-zooms the page when the field gets focus.
        'flex:1;border:none;outline:none;background:transparent;font-family:' + FONT +
        ';font-size:16px;color:#111;padding:8px 4px;direction:' + dir + ';',
        { type: 'text', placeholder: placeholder || T.inputPlaceholder || 'השאלה שלך...', maxLength: 500 });
      input.addEventListener('focus', function () { wrap.style.borderColor = accent; wrap.style.boxShadow = '0 0 0 3px ' + accent + '22'; });
      input.addEventListener('blur', function () { wrap.style.borderColor = '#e6e9ef'; wrap.style.boxShadow = 'none'; });
      // A round arrow, first in the row, so in Hebrew it sits on the right and
      // points outwards, away from the text.
      var send = el('button',
        'flex:0 0 auto;background:' + btnBg + ';color:' + btnTx + ';border:none;border-radius:50%;' +
        'width:38px;height:38px;display:grid;place-items:center;cursor:pointer;font-family:' + FONT +
        ';font-size:17px;line-height:1;transition:.15s;',
        { className: 'pqa-cta', innerHTML: '&#10148;', title: T.submitButton || 'שליחה' });
      send.setAttribute('aria-label', T.submitButton || 'שליחה');
      // Clear the field only if the send was accepted — ask() returns false while
      // a previous answer is still streaming, and wiping the text then loses it.
      function go() { var v = input.value.trim(); if (v && onSend(v) !== false) input.value = ''; }
      send.addEventListener('click', go);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
      wrap.appendChild(send);
      wrap.appendChild(input);
      return { wrap: wrap, input: input };
    }

    function showOtherInput() {
      var f = modal.__footer; f.innerHTML = '';
      var bar = inputBar(function (v) { startChat(v); });
      f.appendChild(bar.wrap);
      bar.input.focus();
    }

    // ============================================================== CHAT VIEW
    var chatBox, chatInput;

    function renderChatShell() {
      modal.innerHTML = '';
      modal.style.height = CHAT_HEIGHT;
      modal.__isChat = true;

      var head = el('div',
        'display:flex;align-items:center;justify-content:space-between;gap:8px;padding:14px 18px;flex:0 0 auto;' +
        'background:linear-gradient(120deg,' + (C.headerGradientFrom || '#111827') + ',' + (C.headerGradientTo || '#2b3242') + ',' + (C.headerGradientFrom || '#111827') + ');' +
        'background-size:200% 100%;animation:pqaHeaderShift 9s ease-in-out infinite;color:#fff;');
      var who = el('div', 'display:flex;align-items:center;gap:11px;');
      var avWrap = el('div', 'position:relative;flex:0 0 auto;');
      var av = avatarEl();
      var dot = el('span',
        'position:absolute;bottom:0;' + (rtl ? 'left:0;' : 'right:0;') +
        'width:11px;height:11px;border-radius:50%;background:#22c55e;border:2px solid #1b2130;animation:pqaPulse 2s infinite;');
      avWrap.appendChild(av); avWrap.appendChild(dot);
      var nameWrap = el('div');
      nameWrap.appendChild(el('div', 'font-weight:700;font-size:15px;', { innerText: T.assistantName || '' }));
      nameWrap.appendChild(el('div', 'font-size:11.5px;opacity:.72;margin-top:1px;', { innerText: T.statusLine || 'מקוונת · עונה תוך רגע' }));
      who.appendChild(avWrap); who.appendChild(nameWrap);
      var btns = el('div', 'display:flex;align-items:center;gap:2px;');
      // "Back to questions" is a Q&A affordance — hide it in thank-you mode.
      if (MODE !== 'thankyou') {
        var back = el('button',
          'background:rgba(255,255,255,.12);border:none;border-radius:9px;cursor:pointer;' +
          'color:rgba(255,255,255,.85);font-family:' + FONT + ';font-weight:600;font-size:12px;' +
          'padding:6px 10px;margin-' + (rtl ? 'left' : 'right') + ':4px;transition:background .15s;',
          { innerText: T.backButton || '☰ כל השאלות' });
        back.addEventListener('mouseenter', function () { back.style.background = 'rgba(255,255,255,.22)'; });
        back.addEventListener('mouseleave', function () { back.style.background = 'rgba(255,255,255,.12)'; });
        back.addEventListener('click', function () { renderSurvey(); });
        btns.appendChild(back);
      }
      var x = closeBtn(); x.style.color = 'rgba(255,255,255,.8)';
      btns.appendChild(x);
      head.appendChild(who); head.appendChild(btns);
      modal.appendChild(head);

      chatBox = el('div',
        'flex:1 1 auto;overflow-y:auto;padding:16px 14px;display:flex;flex-direction:column;gap:11px;background:' + WA_BG + ';',
        { id: 'pqa-scroll' });
      modal.appendChild(chatBox);

      // Thank-you mode: the shopper isn't asking questions, so no input bar.
      if (MODE !== 'thankyou') {
        var barZone = el('div',
          'flex:0 0 auto;padding:10px 12px;border-top:1px solid #eef0f3;background:#fff;direction:' + dir + ';');
        var bar = inputBar(function (v) { return ask(v); }, T.inputPlaceholder);
        chatInput = bar.input;
        barZone.appendChild(bar.wrap);
        modal.appendChild(barZone);
      }
    }

    function scrollDown() { if (chatBox) chatBox.scrollTop = chatBox.scrollHeight; }

    function bubble(role) {
      var isUser = role === 'user';
      var b = el('div',
        'max-width:84%;flex:0 0 auto;padding:11px 14px;font-size:14.5px;line-height:1.55;word-break:break-word;animation:pqaMsg .22s ease;' +
        'align-self:' + (isUser ? 'flex-start' : 'flex-end') + ';' +
        (isUser
          ? 'background:' + (C.userBubbleBackground || '#111') + ';color:' + (C.userBubbleText || '#fff') +
            ';border-radius:16px 16px 4px 16px;'
          : 'background:' + (C.aiBubbleBackground || '#f4f5f7') + ';color:' + (C.aiBubbleText || '#1f2430') +
            ';border-radius:16px 16px 16px 4px;box-shadow:0 1px 2px rgba(0,0,0,.04);') +
        'direction:' + dir + ';');
      chatBox.appendChild(b); scrollDown();
      return b;
    }

    function typingBubble() {
      var b = el('div',
        'align-self:flex-end;background:#ffffff;box-shadow:0 1px 1.5px rgba(0,0,0,.08);' +
        'border-radius:16px 16px 16px 4px;padding:14px 16px;display:flex;gap:6px;animation:pqaMsg .2s ease;');
      // Slower, larger dots read as a person thinking rather than a spinner.
      for (var i = 0; i < 3; i++) b.appendChild(el('span',
        'width:8px;height:8px;border-radius:50%;background:#8696a0;animation:pqaBlink 1.5s infinite ' + (i * 0.25) + 's;'));
      chatBox.appendChild(b); scrollDown();
      return b;
    }

    // Render answer text: strip URLs into pill buttons, render **bold**, keep line breaks.
    function renderAnswer(container, text) {
      var urls = [];
      var body = text.replace(/(https?:\/\/[^\s<]+)/g, function (u) {
        urls.push(u.replace(/[.,)]+$/, '')); return '';
      }).replace(/\n{3,}/g, '\n\n').trim();

      var html = esc(body).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>');
      container.innerHTML = html;

      if (urls.length) {
        var pills = el('div', 'display:flex;flex-wrap:wrap;gap:7px;margin-top:10px;');
        urls.forEach(function (u) {
          var isWa = /wa\.me|whatsapp/.test(u.toLowerCase());
          var a = el('a',
            'display:inline-flex;align-items:center;gap:5px;text-decoration:none;font-size:13px;font-weight:600;' +
            'padding:8px 13px;border-radius:10px;transition:.15s;cursor:pointer;direction:' + dir + ';' +
            (isWa
              ? 'background:#25d366;color:#fff;'
              : 'background:#fff;color:' + accent + ';border:1.5px solid ' + accent + ';'),
            { className: 'pqa-pill', href: u, target: '_blank', rel: 'noopener', innerText: linkLabel(u, T) });
          pills.appendChild(a);
        });
        container.appendChild(pills);
      }
      scrollDown();
    }

    // Bundle prices (cfg.quantityTotals) and the bundle nudge (text.postAddNote)
    // describe ONE specific product. The store also sells a sleep mask and two
    // e-books, and the widget runs on their pages too - showing "2 units = ₪299"
    // next to a ₪59 mask would be a false price. So bundles only apply when the
    // page we are on IS the product the config is describing.
    function bundlesApply() {
      if (!PAGE_HANDLE) return true;                 // home/blog: config default
      return PAGE_HANDLE === String(cfg.productHandle || '').toLowerCase();
    }

    // ---- product card with real add-to-cart ----
    function renderProductCard(qty) {
      qty = qty || 1;
      // productDisplay (title, price, compareAt, image, variant) describes the ONE
      // product this config is about. On another product's page (the sleep mask,
      // an e-book) every one of those fields would be a false claim - a ₪59 mask
      // showing "₪282" struck through. There we trust only the live Shopify data.
      var pd = bundlesApply() ? (cfg.productDisplay || {}) : {};
      var title = (liveProduct && liveProduct.title) || pd.title || 'המוצר';
      var img = (liveProduct && (liveProduct.featured_image || (liveProduct.images && liveProduct.images[0]))) || pd.image || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      function money(cents) { return '₪' + Math.round(cents / 100); }
      // Per-unit money can land on halves (299/2 = 149.5) — show one decimal only when needed.
      function moneyUnit(cents) { var s = Math.round(cents / 10) / 10; return '₪' + s; }
      var baseCents = liveProduct ? liveProduct.price
        : ((parseInt(String(pd.price || '').replace(/[^0-9]/g, ''), 10) || 0) * 100);
      var price = liveProduct ? money(liveProduct.price) : (pd.price || '');
      var compare = liveProduct && liveProduct.compare_at_price && liveProduct.compare_at_price > liveProduct.price
        ? money(liveProduct.compare_at_price) : (pd.compareAt || '');
      // Multi-unit ask: the BIG price is the effective per-unit price of THIS
      // bundle (deal total ÷ quantity), with the regular unit price struck out.
      var dealTotalCents = 0;
      if (qty > 1) {
        var dealStr = bundlesApply() ? String((cfg.quantityTotals || {})[String(qty)] || '') : '';
        var dm = dealStr.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        dealTotalCents = dm ? Math.round(parseFloat(dm[1]) * 100) : (baseCents * qty);
        if (dealTotalCents && qty) {
          var perUnit = dealTotalCents / qty;
          price = moneyUnit(perUnit);
          compare = (baseCents && perUnit < baseCents) ? money(baseCents) : compare;
        }
      }
      // pick variant: page-selected → first available → config default.
      // The page-selected id is only trusted when it actually belongs to the product
      // whose page we are on. Themes render add-to-cart forms for recommended
      // products and bundle apps too, and grabbing the first one would quietly add
      // the wrong product to the cart on a multi-product store.
      var variantId = pd.defaultVariantId;
      try {
        var live = liveProduct && liveProduct.variants
          ? liveProduct.variants.map(function (v) { return String(v.id); }) : null;
        var sel = document.querySelector('form[action^="/cart/add"] [name="id"]');
        var selId = sel && sel.value ? String(sel.value) : '';
        if (selId && (!live || live.indexOf(selId) !== -1)) variantId = selId;
        else if (liveProduct && liveProduct.variants) {
          var av = liveProduct.variants.filter(function (v) { return v.available; })[0] || liveProduct.variants[0];
          if (av) variantId = av.id;
        }
      } catch (e) {}

      var card = el('div',
        // flex:0 0 auto is critical: overflow:hidden zeroes the flex min-height,
        // so without it the card collapses to a hairline once the chat scrolls.
        'align-self:stretch;flex:0 0 auto;background:#fff;border:1.5px solid #e9ecf1;border-radius:16px;overflow:hidden;' +
        'box-shadow:0 4px 14px rgba(0,0,0,.06);animation:pqaMsg .25s ease;direction:' + dir + ';');
      var top = el('div', 'display:flex;gap:12px;padding:12px;align-items:center;');
      if (img) top.appendChild(el('img',
        'width:74px;height:74px;border-radius:12px;object-fit:cover;flex:0 0 auto;background:#f2f4f7;',
        { src: img, alt: title }));
      var info = el('div', 'flex:1;min-width:0;');
      info.appendChild(el('div',
        'font-weight:700;font-size:14px;color:#0b0b0f;line-height:1.35;', { innerText: title }));
      var pr = el('div', 'display:flex;align-items:center;gap:8px;margin-top:6px;');
      pr.appendChild(el('span', 'font-weight:800;font-size:17px;color:#0b0b0f;', { innerText: price }));
      if (qty > 1) pr.appendChild(el('span', 'font-size:12px;color:#7c8494;font-weight:600;',
        { innerText: T.perUnitWord || 'ליחידה' }));
      if (compare) pr.appendChild(el('span',
        'font-size:13px;color:#9aa2b1;text-decoration:line-through;', { innerText: compare }));
      info.appendChild(pr);
      // Below the per-unit price: the bundle total, with the undiscounted
      // total (qty × regular price) struck through when there is a real deal.
      if (qty > 1 && dealTotalCents) {
        var totalLine = el('div', 'margin-top:5px;font-size:13.5px;font-weight:800;color:' + accent + ';');
        totalLine.innerText = (T.qtyTotalWord || 'סה"כ') + ' ל-' + qty + ' ' + (T.unitsWord || 'יחידות') + ': ' + money(dealTotalCents) + ' ';
        var fullCents = baseCents * qty;
        if (fullCents > dealTotalCents) {
          totalLine.appendChild(el('span',
            'color:#9aa2b1;text-decoration:line-through;font-weight:600;font-size:12px;', { innerText: money(fullCents) }));
        }
        info.appendChild(totalLine);
      }
      top.appendChild(info);
      card.appendChild(top);

      var actions = el('div', 'padding:0 12px 12px;display:flex;flex-direction:column;gap:8px;');
      var addBtn = el('button',
        'width:100%;padding:13px;border:none;border-radius:12px;cursor:pointer;font-family:' + FONT +
        ';font-weight:800;font-size:15px;background:' + btnBg + ';color:' + btnTx + ';transition:.15s;',
        { className: 'pqa-cta', innerText: T.addToCart || 'הוספה לעגלה 🛒' });
      actions.appendChild(addBtn);
      // Risk-reversal line right under the buy button (config: text.cartNote).
      if (T.cartNote) actions.appendChild(el('div',
        'font-size:11.5px;color:#7c8494;text-align:center;font-weight:500;', { innerText: T.cartNote }));
      card.appendChild(actions);
      chatBox.appendChild(card); scrollDown();

      addBtn.addEventListener('click', function () {
        if (!variantId) { window.location.href = (liveProduct && liveProduct.url) || (cfg.cart && cfg.cart.cartUrl) || '/cart'; return; }
        addBtn.disabled = true; addBtn.style.opacity = '.7'; addBtn.innerText = T.adding || 'מוסיף...';
        // Cart-aware: if this variant is already in the cart (added earlier from
        // the page or a previous chat click), SET its quantity to the requested
        // amount instead of piling on duplicates the shopper didn't intend.
        var alreadyInCart = 0;
        fetch('/cart.js').then(function (r) { return r.ok ? r.json() : { items: [] }; }).catch(function () { return { items: [] }; })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (it) { return String(it.variant_id) === String(variantId); })[0];
          alreadyInCart = line ? line.quantity : 0;
          if (alreadyInCart === qty) return { noop: true };
          if (alreadyInCart > 0) {
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(variantId), quantity: qty }),
            }).then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); });
          }
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty }),
          }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
        }).then(function () {
          track('pqa_add_to_cart', { product: PRODUCT, quantity: qty });
          addBtn.style.background = '#16a34a'; addBtn.style.opacity = '1';
          addBtn.innerText = (alreadyInCart > 0 && alreadyInCart !== qty)
            ? ('✓ ' + (T.cartUpdated || 'עודכן: {n} בעגלה').replace('{n}', qty))
            : (alreadyInCart === qty
              ? ('✓ ' + (T.alreadyInCart || 'כבר בעגלה ({n})').replace('{n}', qty))
              : (T.addedToCart || '✓ נוסף לעגלה'));
          var co = el('a',
            'width:100%;box-sizing:border-box;text-align:center;padding:13px;border-radius:12px;text-decoration:none;' +
            'font-weight:800;font-size:15px;background:' + accent + ';color:#fff;display:block;transition:.15s;',
            { className: 'pqa-cta', href: (cfg.cart && cfg.cart.checkoutUrl) || '/checkout',
              innerText: T.checkout || 'מעבר לתשלום' });
          co.addEventListener('click', function () { track('pqa_checkout_click', { product: PRODUCT }); });
          actions.appendChild(co);
          // Post-add upsell nudge (config: text.postAddNote) — e.g. the 3-pack deal.
          // Skipped when the shopper already added a multi-unit bundle.
          if (T.postAddNote && qty === 1 && bundlesApply()) {
            var up = bubble('assistant');
            renderAnswer(up, T.postAddNote);
          }
        }).catch(function () {
          addBtn.disabled = false; addBtn.style.opacity = '1'; addBtn.style.background = btnBg;
          addBtn.innerText = T.addToCart || 'הוספה לעגלה 🛒';
          window.location.href = (liveProduct && liveProduct.url) || '/cart';
        });
      });
    }

    // ---- quick-reply chips ----
    function showQuickReplies() {
      var qs = (cfg.quickReplies || []).slice();
      if (cfg.cart && cfg.cart.enabled && T.buyIntentChip) qs.push('__BUY__');
      if (!qs.length) return;
      var row = el('div',
        'align-self:flex-end;flex:0 0 auto;display:flex;flex-wrap:wrap;gap:7px;max-width:92%;margin-top:2px;animation:pqaMsg .25s ease;');
      qs.forEach(function (q) {
        var isBuy = q === '__BUY__';
        var label = isBuy ? T.buyIntentChip : q;
        var chip = el('button',
          'background:' + (isBuy ? btnBg : '#fff') + ';color:' + (isBuy ? btnTx : '#374151') +
          ';border:1.5px solid ' + (isBuy ? btnBg : '#e2e6ec') + ';border-radius:20px;padding:8px 14px;cursor:pointer;' +
          'font-family:' + FONT + ';font-weight:600;font-size:13px;transition:.15s;', { className: 'pqa-chip', innerText: label });
        chip.addEventListener('click', function () {
          // While an answer is still streaming, keep the chips so the tap isn't lost.
          if (!isBuy && busy) return;
          row.remove();
          if (isBuy) { bubble('user').innerText = label; renderProductCard(); }
          else ask(q);
        });
        row.appendChild(chip);
      });
      chatBox.appendChild(row); scrollDown();
    }

    // ---- conversation ----
    function startChat(firstQuestion) {
      renderChatShell();
      // Coming back from the question menu mid-conversation? Replay the history
      // so the new question continues the same chat instead of wiping it.
      messages.forEach(function (m) {
        if (m.role === 'user') bubble('user').innerText = m.content;
        else renderAnswer(bubble('assistant'), m.content);
      });
      var st = readState(); st.opened = true; writeState(st);
      ask(firstQuestion);
    }

    function afterAnswer(fullText) {
      var cartMatch = fullText.match(/\[\[CART(?::(\d+))?\]\]/);
      if (fullText) { messages.push({ role: 'assistant', content: fullText.replace(/\[\[CART(?::\d+)?\]\]/g, '').trim() }); saveChat(); }
      if (cartMatch) {
        // Quantity the shopper asked for, capped defensively.
        var qty = Math.max(1, Math.min(parseInt(cartMatch[1] || '1', 10) || 1, 10));
        renderProductCard(qty);
      }
      if (!quickRepliesShown) { quickRepliesShown = true; setTimeout(showQuickReplies, 250); }
      scrollDown();
    }

    function ask(question) {
      if (busy) return false;
      busy = true;
      messages.push({ role: 'user', content: question });
      saveChat();
      track('pqa_question', { product: PRODUCT, turn: messages.length });
      bubble('user').innerText = question;
      var typing = typingBubble();
      var acc = '', gotError = null, t0 = Date.now(), revealed = false;

      // A person doesn't type word-by-word into your screen: they think, and
      // then a whole message lands. So we buffer the entire answer, keep the
      // typing dots up for a plausible beat, and drop the message in one piece.
      // Longer answers get a slightly longer pause, capped so it never drags.
      function reveal(text, isError) {
        if (revealed) return;
        revealed = true;
        var clean = String(text || '').replace(/\[\[CART(?::\d+)?\]\]/g, '');
        var think = Math.min(1100 + clean.length * 14, 4200);
        var wait = Math.max(0, think - (Date.now() - t0));
        setTimeout(function () {
          if (typing.parentNode) typing.remove();
          renderAnswer(bubble('assistant'), clean);
          busy = false;
          if (!isError) afterAnswer(acc);
        }, wait);
      }

      var pageText = '';
      try { pageText = (document.body.innerText || '').slice(0, 6000); } catch (e) {}

      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 60000);

      fetch(API_BASE + '/api/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product: PRODUCT, handle: PAGE_HANDLE || undefined, messages: messages, pageText: pageText, locale: LOCALE || undefined, chatId: CHAT_ID }),
        signal: ctrl && ctrl.signal,
      }).then(function (resp) {
        if (!resp.ok || !resp.body) throw new Error('bad');
        var reader = resp.body.getReader(), decoder = new TextDecoder(), buf = '';
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) { finalize(); return; }
            buf += decoder.decode(res.value, { stream: true });
            var parts = buf.split('\n\n'); buf = parts.pop();
            parts.forEach(handle);
            return pump();
          });
        }
        function handle(chunk) {
          var ev = /event:\s*(.+)/.exec(chunk), dm = /data:\s*([\s\S]+)/.exec(chunk);
          if (!ev || !dm) return;
          var type = ev[1].trim(); var data;
          try { data = JSON.parse(dm[1]); } catch (e) { return; }
          // Deltas only accumulate — nothing hits the screen until it's whole.
          if (type === 'delta') {
            acc += data.text || '';
          } else if (type === 'done') {
            acc = data.text || acc;
          } else if (type === 'error') {
            gotError = data.text || 'תקלה זמנית.';
          }
        }
        function finalize() {
          if (timer) clearTimeout(timer);
          if (gotError) reveal(gotError, true);
          else reveal(acc, false);
        }
        return pump();
      }).catch(function () {
        if (timer) clearTimeout(timer);
        reveal((T.errorMessage || 'מצטערים, יש תקלה זמנית. אפשר לפנות אלינו בוואטסאפ') +
          ' ' + (cfg.whatsapp || ''), true);
      });
    }

    // ============================================================ THANK-YOU UPSELL
    // Order-status page: Maya greets the buyer personally and presents a few
    // add-on offers they can scroll through, each with her note above it.
    // Accepting = a discounted checkout permalink (works with any gateway incl. Grow).
    function offerCheckoutUrl(o) {
      var shop = (cfg.thankYou && cfg.thankYou.shopDomain) || '';
      var redirect = '/cart/' + o.variantId + ':1';
      return o.discountCode
        ? shop + '/discount/' + encodeURIComponent(o.discountCode) + '?redirect=' + encodeURIComponent(redirect)
        : shop + redirect;
    }
    function renderThankYouOffer(o) {
      var money = function (s) { return s; };
      var card = el('div',
        'align-self:stretch;flex:0 0 auto;background:#fff;border:1.5px solid #e9ecf1;border-radius:16px;overflow:hidden;' +
        'box-shadow:0 4px 14px rgba(0,0,0,.06);animation:pqaMsg .25s ease;direction:' + dir + ';margin-top:2px;');
      var top = el('div', 'display:flex;gap:12px;padding:12px;align-items:center;');
      if (o.image) top.appendChild(el('img',
        'width:70px;height:70px;border-radius:12px;object-fit:cover;flex:0 0 auto;background:#f2f4f7;',
        { src: o.image, alt: o.title }));
      var info = el('div', 'flex:1;min-width:0;');
      info.appendChild(el('div', 'font-weight:700;font-size:14px;color:#0b0b0f;line-height:1.35;', { innerText: o.title }));
      var pr = el('div', 'display:flex;align-items:center;gap:8px;margin-top:6px;flex-wrap:wrap;');
      pr.appendChild(el('span', 'font-weight:800;font-size:17px;color:#0b0b0f;', { innerText: money(o.priceText) }));
      if (o.compareText) pr.appendChild(el('span',
        'font-size:13px;color:#9aa2b1;text-decoration:line-through;', { innerText: money(o.compareText) }));
      if (o.savePct) pr.appendChild(el('span',
        'font-size:12px;font-weight:800;color:' + accent + ';', { innerText: 'חסכון ' + o.savePct + '%' }));
      info.appendChild(pr);
      top.appendChild(info);
      card.appendChild(top);
      var TT = (cfg.thankYou && cfg.thankYou.text) || {};
      var btn = el('a',
        'display:block;box-sizing:border-box;margin:0 12px 12px;text-align:center;padding:13px;border-radius:12px;' +
        'text-decoration:none;font-family:' + FONT + ';font-weight:800;font-size:15px;background:' + btnBg + ';color:' + btnTx + ';',
        { className: 'pqa-cta', href: offerCheckoutUrl(o), innerText: TT.add || 'כן, הוסיפו לי 🛒' });
      btn.addEventListener('click', function () { track('pqa_ty_accept', { product: PRODUCT, variant: o.variantId }); });
      card.appendChild(btn);
      chatBox.appendChild(card); scrollDown();
    }
    function renderThankYou() {
      var ty = cfg.thankYou || {};
      renderChatShell();
      // Maya's opening line, then her note + card for each offer (scrollable).
      renderAnswer(bubble('assistant'), ty.greeting || 'תודה על ההזמנה! 🎉');
      track('pqa_ty_shown', { product: PRODUCT, offers: (ty.offers || []).length });
      (ty.offers || []).forEach(function (o, i) {
        setTimeout(function () {
          if (o.mayaNote) renderAnswer(bubble('assistant'), o.mayaNote);
          renderThankYouOffer(o);
        }, 350 * (i + 1));
      });
      // A gentle "no thanks" at the end.
      setTimeout(function () {
        var skip = el('div', 'align-self:flex-end;flex:0 0 auto;margin-top:6px;');
        var b = el('button',
          'background:#fff;color:#6b7280;border:1.5px solid #e2e6ec;border-radius:20px;padding:8px 16px;cursor:pointer;' +
          'font-family:' + FONT + ';font-weight:600;font-size:13px;', { className: 'pqa-chip', innerText: (ty.text && ty.text.skipAll) || 'לא תודה, סיימתי' });
        b.addEventListener('click', function () { track('pqa_ty_decline', { product: PRODUCT }); closeModal(); });
        skip.appendChild(b); chatBox.appendChild(skip); scrollDown();
      }, 350 * ((ty.offers || []).length + 1));
    }

    if (MODE === 'thankyou') {
      if (!cfg.thankYou || !(cfg.thankYou.offers || []).length) return;
      renderThankYou();
      setTimeout(function () { if (!opened) { opened = true; openModal(); } }, 1500);
      return;
    }

    // ------------------------------------------------------ first appearance
    // Auto-popup only for visitors who haven't engaged AND haven't dismissed it
    // in the last 24h. Everyone else gets the quiet side tab.
    renderSurvey();
    var st = readState();
    var delay = typeof cfg.delayMs === 'number' ? cfg.delayMs : 12000;
    var DAY = 24 * 60 * 60 * 1000;
    var recentlyDismissed = st.dismissedAt && (Date.now() - st.dismissedAt < DAY);
    // A shopper who was mid conversation and clicked through to another page
    // used to lose the chat off screen and have to find the button again. If
    // the panel was open moments ago, bring it back where they left it. Only
    // on desktop: on a phone the chat owns the screen, and reopening it over
    // a page the shopper just chose would be taking the wheel from them.
    var carriedOver = !isMobile && st.panelOpenAt && (Date.now() - st.panelOpenAt < 10 * 60 * 1000) && readChat().length;
    if (carriedOver) { opened = true; openModal(); }   // openModal replays the saved chat
    else if (!ON_PRODUCT_PAGE) { tab.style.display = 'flex'; syncHint(); }   // site-wide: quiet tab only
    else if (st.opened || recentlyDismissed) { tab.style.display = 'flex'; syncHint(); }
    else { tab.style.display = 'flex'; syncHint(); }   // הוראת בעלים 31.08: לעולם לא פתיחה אוטומטית - הפינה עם השאלות בלבד
  }
})();
